import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISharpenModule, ISharpenPagedResponse, ISharpenTrack, ISharpenVideoData } from '@shared/models/sharpen-data-model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpSharpenService {

  constructor(private http: HttpClient) { }

  getAllTracks(page?: number): Observable<ISharpenPagedResponse<ISharpenTrack>> {
    return this.http.get<ISharpenPagedResponse<ISharpenTrack>>(`${environment.sharpenApi}/tracks`, {
      params: {
        page: `${page ?? 1}`,
      }
    });
  }

  getModulesByIds(ids: number[]): Observable<ISharpenPagedResponse<ISharpenModule>> {
    return this.http.get<ISharpenPagedResponse<ISharpenModule>>(`${environment.sharpenApi}/modules`, {
      params: {
        module_ids: `${ids.join(',')}`,
      }
    });
  }

  getModuleById(id: string): Observable<ISharpenModule> {
    return this.http.get<ISharpenModule>(`${environment.sharpenApi}/modules/${id}`);
  }

  getVideoById(id: number): Observable<ISharpenVideoData> {
    return this.http.get<ISharpenVideoData>(`${environment.sharpenApi}/videos/${id}`);
  }

  trackEvent(contentType: string, actionType: string, title: string, userId: string) {
    return this.http.post<any>(`${environment.sharpenAnalytics}`, {}, {
      params: {
        idsite: environment.sharpenAnalyticsType,
        rec: '1',
        e_c: contentType,
        e_a: actionType,
        e_n: title,
        e_v: '1',
        dimension2: 'Vescent',
        uid: userId,
      }
    })
  }
}
